import { render } from "./announcement_editor.vue?vue&type=template&id=643e229c"
import script from "./announcement_editor.js?vue&type=script&lang=js"
export * from "./announcement_editor.js?vue&type=script&lang=js"

import "./announcement_editor.vue?vue&type=style&index=0&id=643e229c&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__